// extracted by mini-css-extract-plugin
module.exports = {"header":"ColumnHeader_header__2uTtJ"};